import React, { useEffect, useState } from "react";
import {
  Button,
  Modal,
  ModalBody,
  Input,
  Label,
  FormGroup,
  Form,
} from "reactstrap";
import { toast } from "react-toastify";
import * as Yup from "yup";
import {
  addDocRequired,
  getDocRequiredDataById,
  updateDocRequired,
} from "model/DocRequiredModel";

const docRequiredSchema = Yup.object().shape({
  name: Yup.string().trim().required("Name is required"),
  status: Yup.boolean(),
});

const DocRequiredAddEditModal = ({
  setDocRequiredAddEditModalOpen,
  docRequiredAddEditModalOpen,
  getDocRequiredList,
  itemId,
  setFormData,
  formData,
}) => {
  const [formKey, setFormKey] = useState(0);
  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      await docRequiredSchema.validate(formData, { abortEarly: false });
      setErrors({});
    } catch (err) {
      const newErrors = {};
      err.inner.forEach((error) => {
        newErrors[error.path] = error.message;
      });
      setErrors(newErrors);
      return;
    }

    const params = {
      name: formData?.name,
      status: formData?.status ? "active" : "deactive",
      // compatibility fallback
      jobCategoryName: formData?.name,
      jobCategoryStatus: formData?.status ? "active" : "deactive",
    };

    let response;
    if (itemId) {
      response = await updateDocRequired(itemId, params);
    } else {
      response = await addDocRequired(params);
    }

    if (response?.success) {
      toast.success(response?.message);
      closeModal();
      getDocRequiredList?.();
    } else {
      toast.error(response?.message);
    }
  };

  const closeModal = () => {
    setDocRequiredAddEditModalOpen(false);
    setErrors({});
  };

  const getFetchDocRequiredById = async (id) => {
    const response = await getDocRequiredDataById({ Id: id });
    if (response?.data) {
      setFormData({
        name: response?.data?.name || response?.data?.jobCategoryName || "",
        status:
          response?.data?.status === "active" ||
          response?.data?.jobCategoryStatus === "active",
      });
      setFormKey((k) => k + 1);
    }
  };

  useEffect(() => {
    if (itemId) {
      getFetchDocRequiredById(itemId);
    }
  }, [itemId]);


  return (
    <Modal
    isOpen={docRequiredAddEditModalOpen}
    toggle={closeModal}
      backdrop="static"
      className="modal-full-height"
      centered

    >
      <ModalBody
        key={formKey}
        className="p-4"
        style={{ maxHeight: "95vh", overflowY: "auto" }}
      >
        <div className="d-flex justify-content-between align-items-center mb-3">
          <h5 className="fw-bold mb-0">{itemId ? "Edit" : "Create"} Doc Required</h5>
          <Button close onClick={closeModal} />
        </div>
        <hr />

        <Form onSubmit={handleSubmit}>
          {/* Name */}
          <FormGroup>
            <Label>Name <span className="text-danger">*</span></Label>
            <Input
              type="text"
              name="name"
              value={formData.name}
              onChange={handleChange}
            />
            {errors.name && (
              <small className="text-danger">{errors.name}</small>
            )}
          </FormGroup>

          {/* Status Field */}
          <FormGroup>
            <Label>Status <span className="text-danger">*</span></Label>
            <div className="input-box d-flex align-items-center justify-content-between">
              <span className="text-muted">Type</span>
              <div className="d-flex align-items-center">
                <strong className="me-2">
                  {formData.status ? "Active" : "Inactive"}
                </strong>
                <div className="form-switch">
                  <Input
                    type="switch"
                    name="status"
                    defaultChecked={Boolean(formData.status)}
                    onChange={handleChange}
                  />
                </div>
              </div>
            </div>
          </FormGroup>

          <div className="text-end mt-3">
            <Button color="primary" type="submit">
              {itemId ? "Update" : "Save"}
            </Button>
          </div>
        </Form>
      </ModalBody>
    </Modal>
  );
};

export default DocRequiredAddEditModal;
